<template>
  <!-- 分享简答题 -->
  <div class="short_answer">
    <div v-if="!data.answered">
      <div class="question">
        <div class="title">
          <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
          <span class="span" v-if="data.questionType==8">（每个同学都有1次提交分享机会，提交后还可看到他人的分享~）</span>
          <span class="span" v-if="data.questionType==10&&(data.rule?data.rule.subTitle:false)">{{data.rule.subTitle}}</span>
        </div>
        <div v-if="data.questionDes">
          <div class="text" v-for="o in JSON.parse(data.questionDes)" :key="JSON.stringify(o)" v-text="o.txt"></div>
        </div>
      </div>
      <!-- 答案部分 -->
      <div class="answer">
        <el-input
          type="textarea"
          :rows="data.questionType==8?6:4"
          :maxlength="data.rule?data.rule.length:999999"
          :placeholder="data.rule?(data.rule.placeholder?data.rule.placeholder:'请输入内容'):'请输入内容'"
          v-model="textarea">
        </el-input>
        <div class="answer_footer clear">
          <div class="isPublic fl" v-if="data.questionType==8">
            <el-checkbox v-model="isPublic"></el-checkbox>
            <div class="txt">公开给所有同学可见</div>
          </div>
          <div class="num fr" v-if="data.rule?data.rule.length:false">{{textarea.length}} / {{data.rule.length}}</div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="question">
        <div class="title">
          <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
          <span class="span" v-if="data.questionType==8">（每个同学都有1次提交分享机会，提交后还可看到他人的分享~）</span>
          <span class="span" v-if="data.questionType==10&&(data.rule?data.rule.subTitle:false)">{{data.rule.subTitle}}</span>
        </div>
        <div v-if="data.questionDes">
          <div class="text" v-for="o in JSON.parse(data.questionDes)" :key="JSON.stringify(o)" v-text="o.txt"></div>
        </div>
      </div>
      <!-- 答案部分 -->
      <div class="answer">
        <el-input
          type="textarea"
          :rows="data.questionType==8?6:4"
          :placeholder="data.rule?(data.rule.placeholder?data.rule.placeholder:'请输入内容'):'请输入内容'"
          :disabled="disabledBol"
          v-model="textarea">
        </el-input>
        <div class="answer_footer clear">
          <div class="isPublic fl" v-if="data.questionType==8">
            <el-checkbox v-model="isPublic"></el-checkbox>
            <div class="txt">公开给所有同学可见</div>
          </div>
          <div class="num fr" v-if="data.rule?data.rule.length:false">{{textarea.length}} / {{data.rule.length}}</div>
        </div>
      </div>
      <div class="list_header bold" v-if="otherBol">
        全部回答 （{{totalCount}}）
      </div>
      <div class="list"  v-if="otherBol">
        <dynamic-item
        v-for="(item, index) in otherList"
        v-show="index < 5"
        :hasMargin="false"
        :key="item.examQuestionId"
        :time="item.answerTime"
        :imgUrl="item.icon"
        :menber="item.title"
        :content="item.answer"></dynamic-item>
        <div class="look cursor" v-if="totalCount>5" @click="lookFn">
          查看全部
        </div>
      </div>
    </div>
    <!-- 答案隐藏文字id -->
    <div class="answerObj none">{{answerObj}}</div>
    <div class="isNecessary none">{{data.rule ? (data.rule.isNecessary ? 1 : 0) : 0}}</div>
  </div>
</template>

<script>

import DynamicItem from '@/components/team-homepage/DynamicItem'

export default {
  props: {
    data: Object,
    disabledBol: Boolean     // 是否disabled
  },
  computed: {
    // 答案
    answerObj () {
      let obj
      let length = this.data.rule ? this.data.rule.length : 999999
      if (this.textarea.length > length) {
        obj = {
          msg: '超出答题字数'
        }
      } else if (this.textarea.length === 0) {
        obj = {
          msg: '请填写答案后提交'
        }
      } else {
        obj = {
          questionId: this.data.questionId,
          item: this.textarea
        }
        if (!this.isPublic) {
          obj.isPublic = 0
        }
      }
      return obj
    },
    // 其他回答是否展示
    otherBol () {
      let bol = this.data.rule ? (this.data.rule.notGetAnswer !== 1) : true
      return bol
    }
  },
  name: 'ShortAnswer',
  data () {
    return {
      textarea: '',
      currentPage: 1,    // 单前页码
      otherList: [],
      isPublic: true,    // 是否公开
      totalCount: 0      // 总数
    }
  },
  methods: {
    // 查看全部
    lookFn () {
      let url = `${window.location.href.split('#')[0]}#/AnwersList?taskRelationId=${this.$route.query.taskRelationId}&questionId=${this.data.questionId}&seasonId=${this.$route.query.seasonId}`
      window.open(url)
    },
    // 翻页
    handleCurrentChange () {
      this.getChange()
    },
    // 获取动态
    getChange () {
      if (!this.otherBol) {
        return
      }
      let data = {
        taskRelationId: this.$route.query.taskRelationId,
        questionId: this.data.questionId,
        pageSize: 10,
        startIndex: (this.currentPage - 1) * 10
      }
      this.$api.post('ANSWER_LIST', data, (res) => {
        this.otherList = res.data.list || []
        this.totalCount = res.data.totalCount || 0
      })
    },
    // 初始化
    init () {
      if (this.data.answered) {
        this.textarea = this.data.answered
        this.getChange()
      }
    }
  },
  created () {
    this.init()
  },
  components: {
    DynamicItem
  }
}
</script>
<style lang="scss">
.short_answer{
  textarea{
    resize: none;
    font-size: 14px;
    line-height: 20px;
  }
}
</style>

<style lang="scss" scoped>
.short_answer{
  margin-top: 24px;
  .look{
    text-align: center;
    color: #296bff;
    font-size: 14px;
    line-height: 20px;
    margin-top: 40px;
  }
  .pagination{
    text-align: center;
    margin-top: 16px;
  }
  .answer_footer{
    .isPublic{
      display: flex;
      align-items: center;
      margin-top: 8px;
      .txt{
        color: #909399;
        font-size: 12px;
        line-height: 17px;
        text-align: right;
        margin-left: -22px;
      }
    }
    .num{
      margin-top: 8px;
      color: #909399;
      font-size: 12px;
      line-height: 17px;
      text-align: right;
    }
  }
  .question{
    margin-bottom: 16px;
    .title{
      color: #303133;
      margin-bottom: 8px;
      font-size: 16px;
      line-height: 22px;
      .span{
        color: #909399;
        font-size: 12px;
        line-height: 17px;
        word-break: break-word;
      }
    }
  }
  .text{
    margin-top: 8px;
    color: #606266;
    font-size: 12px;
    line-height: 20px;
    word-break: break-word;
    white-space: pre-wrap;
  }
  .list_header{
    line-height: 25px;
    font-size: 18px;
    line-height: 25px;
    padding-top: 20px;
  }
  .list_header:after{
    content: '';
    width: 784px;
    display: block;
    border-top: 1px solid #EBEEF5;
    margin-left: -40px;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/topic/public/short-answer.vue